/**
 * This Component is intentionally light. It exists separately
 * to ease server side rendering.
 */
import React, {useEffect, useState, useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Route, useLocation} from 'react-router-dom';
import queryString from 'query-string';
import {getTheme} from '@ey/styled-theme';
import styled, {ThemeProvider} from 'styled-components';
import {useFrameService} from '@ey/canvascoreservices';
import './globals.less';
import './app.less';
import App from './App';
import Utility from '../util/utilityfunctions';
import {frameSubEvent, userTheme} from '../util/uiconstants';
import {labels} from '../util/utils';
import TopBarNav from './Common/TopNavBar/TopBarNav';
import Errors from './Common/Errors/Errors';

function Routes() {
	const [darkMode, setDarkMode] = useState(false);
	const userPreferences = useSelector((state) => state.userPreferences);
	const isModalOpen = useSelector((state) => state.isModalOpen);
	const location = useLocation();
	const queryParameters = queryString.parse(location.search.toLowerCase());
	const isDrawerMode = (queryParameters?.isdrawer && queryParameters.isdrawer.toLowerCase() === 'true') || false;
	const frameKey = queryParameters?.framekey || null;
	const frameService = useFrameService();

	const isHelix = useMemo(() => {
		return window.location.pathname.includes('/helixprojects') || window.location.pathname.includes('/connections');
	}, [window.location.pathname]);

	useEffect(() => {
		if (isHelix && isDrawerMode && frameKey) {
			let args = {
				frameKey,
				name: labels.helixProjectTitle,
				updateFrameTitle: true,
				deepLinkSrc: window.location.href,
				subEvent: frameSubEvent.UPDATE_FRAME_TITLE
			};
			frameService.sendMessageToParent(args);
		}
	}, [isHelix]);

	useEffect(() => {
		let isDarkMode = Utility.isUserDarkMode(userPreferences);

		Utility.setMotifTheme(isDarkMode ? userTheme.dark : userTheme.light);
		setDarkMode(isDarkMode);
	}, [userPreferences]);

	const parsed = queryString.parse(window.location.search.toLowerCase());
	const view = parsed.view;

	return (
		<>
			<ThemeProvider theme={getTheme(darkMode)}>
				<StyledLandingContainer role="main" className={`rootWrapper ${isDrawerMode ? 'drawerView' : ''}`}>
					{/*{!isDrawerMode && <Nav />}*/}
					{!isDrawerMode && <TopBarNav />}
					{!isModalOpen && <Errors />}
					<Route path="/" component={App} />
				</StyledLandingContainer>
			</ThemeProvider>
		</>
	);
}

const StyledLandingContainer = styled.section`
	&.rootWrapper {
		.container-fluid {
			margin: 0;
		}
		&.drawerView {
			.main {
				top: 0 !important;
				height: 100% !important;
			}
		}
	}
`;

export default Routes;
